

import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import DetailProduct from './DetailProduct';
import CategoriesScreen from './categories';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import BeersScreen from './beers';
import BottlesScreen from './bottles';

function Index({dishs2, setShowListProduct, setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [dataFood, setDataFood] = useState(false);
    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false); 
    const [grill, setGrill] = useState(false);
    const [ribeye, setRibeye] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [showListProduct2, setShowListProduct2] = useState(false);
    const [dataCocktail, setdataCocktail] = useState (false);
    const [dataDrinks, setdataDrinks] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showBeers, setShowBeers] = useState(false);
     const [showBottles, setShowBottles] = useState(false);
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);
    
     const [drinks, setdrinks] = useState(false);


    useEffect(() => {
        menus.map((item) => {
            if (item.id === 290) {
                setdataCocktail(item);
            }

            if (item.id === 288) {
                setdataDrinks(item);
            }
        });
    }, [menus]);

    useEffect(() => {
        if (dataFood) {
            dataFood.map((item) => {
                if (item.id === 2811) {
                    setGrill(item);
                }
                if (item.id === 2385) {
                    setRibeye(item);
                }
            });
        }
    }, [dataFood]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setShowListProduct} goHome={setShowHappy} goCategories={setshowCategories}
            setShowSpecials={() => {
           setShowSpecials(true)
        }}
            >
                <div  style={{padding: '0 20px'}}>
                    <div style={{ width: '100%', alignItems: 'center', zIndex: 999, display: 'flex', justifyContent:"center", flexDirection:'column' }}>
                        <div
                            onClick={() => {
                                setdishs(dataCocktail)
                                setShowListProduct2(true)
                            }}
                            style={{
                                width: '50%',
                                height: 190,
                                borderRadius: 14,
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative',
                                display: 'flex',
                                justifyContent: "center",
                                flexDirection: 'column',
                                 boxShadow: "1px 1px 6px #ED6DEC",
                               
                            }}>
                            <div
                            style={{
                                width: '100%',
                                height: '100%',
                                backgroundColor: '#0404041f',
                                position: 'absolute',
                                borderRadius: 10,
                                    zIndex: 100,
                               
                               
                            }}></div>
                            <img
                            style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: 13,
                                objectFit: 'cover',
                                    opacity: 1,
                                 border: '3px solid #e26ed6',
                              
                                
                            }}
                            src={require('./assets/Cocktails.png')}
                            />
                            <p
                                 className="text-shadow"
                            style={{
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                fontSize: 27,
                                marginTop: 5,
                                position: 'absolute',
                                zIndex: 9999,
                                color: 'white',
                                textShadowColor: '#000', // Color de la sombra
                                textShadowOffset: {width: 4, height: 1},
                                textShadowRadius: 3,
                            }}>
                            {langEng ? 'Cocktails' : 'Cocteles'}
                            </p>
                        </div>

                        <div
                            onClick={() => {
                                setdishs(dataDrinks)
                                setShowListProduct2(true)
                            }}
                            style={{
                                marginTop: 20,
                                width: '50%',
                                height: 190,
                                borderRadius: 14,
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative',
                                display: 'flex',
                                justifyContent: "center",
                                flexDirection: 'column',
                                boxShadow: "1px 1px 6px #ED6DEC",
                               
                            }}>
                            <div
                            style={{
                                width: '100%',
                                height: '100%',
                                backgroundColor: '#0404041f',
                                position: 'absolute',
                                borderRadius: 10,
                                    zIndex: 100,
                                     boxShadow: "1px 1px 6px #ED6DEC",
                               
                               
                            }}></div>
                            <img
                            style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: 13,
                                objectFit: 'cover',
                                    opacity: 1,
                                 border: '3px solid #e26ed6',
                              
                                
                            }}
                            src={require('./assets/drinks.png')}
                            />
                            <p
                                 className="text-shadow"
                            style={{
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                fontSize: 27,
                                marginTop: 5,
                                position: 'absolute',
                                zIndex: 9999,
                                color: 'white',
                                textShadowColor: '#000', // Color de la sombra
                                textShadowOffset: {width: 4, height: 1},
                                textShadowRadius: 3,
                            }}>
                            {langEng ? 'Drinks' : 'Bebidas'}
                            </p>
                        </div>

                        <div
                            onClick={() => {
                              setShowBeers(true)
                            }}
                            style={{
                                marginTop: 20,
                                width: '50%',
                                height: 190,
                                borderRadius: 14,
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative',
                                display: 'flex',
                                justifyContent: "center",
                                flexDirection: 'column',
                                boxShadow: "1px 1px 6px #ED6DEC",
                               
                            }}>
                            <div
                            style={{
                                width: '100%',
                                height: '100%',
                                backgroundColor: '#0404041f',
                                position: 'absolute',
                                borderRadius: 10,
                                    zIndex: 100,
                                     boxShadow: "1px 1px 6px #ED6DEC",
                               
                               
                            }}></div>
                            <img
                            style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: 13,
                                objectFit: 'cover',
                                    opacity: 1,
                                 border: '3px solid #e26ed6',
                              
                                
                            }}
                            src={require('./assets/Beers.png')}
                            />
                            <p
                                 className="text-shadow"
                            style={{
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                fontSize: 27,
                                marginTop: 5,
                                position: 'absolute',
                                zIndex: 9999,
                                color: 'white',
                                textShadowColor: '#000', // Color de la sombra
                                textShadowOffset: {width: 4, height: 1},
                                textShadowRadius: 3,
                            }}>
                             {langEng ? 'Beers' : 'Cervezas'}
                            </p>
                        </div>

                        <div
                            onClick={() => {
                              setShowBottles(true)
                            }}
                            style={{
                                marginTop: 20,
                                width: '50%',
                                height: 190,
                                borderRadius: 14,
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative',
                                display: 'flex',
                                justifyContent: "center",
                                flexDirection: 'column',
                                boxShadow: "1px 1px 6px #ED6DEC",
                               
                            }}>
                            <div
                            style={{
                                width: '100%',
                                height: '100%',
                                backgroundColor: '#0404041f',
                                position: 'absolute',
                                borderRadius: 10,
                                    zIndex: 100,
                                     boxShadow: "1px 1px 6px #ED6DEC",
                               
                               
                            }}></div>
                            <img
                            style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: 13,
                                objectFit: 'cover',
                                    opacity: 1,
                                 border: '3px solid #e26ed6',
                              
                                
                            }}
                            src={require('./assets/Bottles.png')}
                            />
                            <p
                                 className="text-shadow"
                            style={{
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                fontSize: 27,
                                marginTop: 5,
                                position: 'absolute',
                                zIndex: 9999,
                                color: 'white',
                                textShadowColor: '#000', // Color de la sombra
                                textShadowOffset: {width: 4, height: 1},
                                textShadowRadius: 3,
                            }}>
                             {langEng ? 'Bottles' : 'Botellas'}
                            </p>
                        </div>
                    </div>

                    
                        <img
                            src={require('./assets/1.png')}
                            style={{
                            width: 270,
                            height: 880,
                            objectFit: 'contain',
                            position: 'absolute',
                                right: -40,
                            top: 0
                            }}
                        />
                        <img
                            src={require('./assets/2.png')}
                            style={{
                            width: 470,
                            height: 880,
                            objectFit: 'contain',
                            position: 'absolute',
                                left: -30,
                            top:80
                            }}
                        
                        />
                   

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}

                            
                 {showListProduct2 && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct2}
                    goHome={setshowCategories}
                />}

                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowDetailProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}

                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setshowCategories} />}
                {showBeers && <BeersScreen setShowListProduct={setShowBeers} setShowHappy={setshowCategories} />}
                 {showBottles && <BottlesScreen setShowListProduct={setShowBottles} setShowHappy={setshowCategories} />}
            </LayoutContent>
        </div>
    );
}
export default Index;